import { PageTitle } from "../../components/PageTitle";
import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { ShieldExport } from "./components/ShieldExport/ShieldExport";
import { ShieldPage } from "./components/ShieldPage/ShieldPage";

const shieldBreadcrumbs = [
  {
    title: "Safety & Compliance",
    path: "",
    isSeparator: false,
    isActive: true,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const ShieldWrapper = () => {
  const { currentOrganization } = useOrganizationContext();

  return (
    <>
      <div className="wrapper-header-export-btn-question-history">
        <PageTitle
          breadcrumbs={shieldBreadcrumbs}
          breadcrumbTitle="Shield"
          pageTitle="Shield (blocked prompts)"
        />
        <div className="d-flex align-items-center position-relative w-350px justify-content-sm-end">
          <ShieldExport organization={currentOrganization?.id || ""} />
          {/* <ShieldSettings /> */}
        </div>
      </div>
      {currentOrganization && (
        <ShieldPage currentOrganization={currentOrganization} />
      )}
    </>
  );
};

export { ShieldWrapper };
